import { useTranslation } from "react-i18next"
import { Link } from "../navigation";

import { useDesigns } from "./DesignsProvider";
import { Comment } from "../comments/Comments";
import { design_family, design_registration } from "../data";
import { useComments } from "../comments/CommentsProvider";
import { useRoles } from "../user/Auth";

export default function DesignComments({registrationId, familyId}: {
    registrationId?: number;
    familyId?: number;
}) {
    const {registrationById, familyById} = useDesigns()
    const {commentsLookUp} = useComments()

    const family = familyById[familyId]
    const registration = registrationId && registrationById[registrationId]

    return (
        <div className="flex flex-col gap-2">
            {familyId !== undefined
                ? <DesignEntityComments entity={design_family} entityId={familyId} comments={commentsLookUp[design_family]?.[familyId] ?? []} name={family?.reference} />
                : registration === undefined
                ? null
                : <DesignEntityComments entity={design_registration} entityId={registration.registrationId} comments={commentsLookUp[design_registration]?.[registration.registrationId] ?? []} name={registration.reference} />
            }
        </div>
    )
}

function DesignEntityComments({
  entity,
  entityId,
  comments,
  name,
}: {
  name: string
  entity: string
  entityId: number
  comments: any[]
}) {
  const { t } = useTranslation()
  const { isEditUser } = useRoles()

  const addButtonStyle = 'btn-secondary bg-white text-sm whitespace-nowrap min-w-fit py-0.5'

    return (
      <div>
        <div className="flex flex-row pb-4 px-1">
          <h3 className="grow">{t('comments')}</h3>
          {isEditUser && (
            <Link title={t('add-comment')} to={`comments?entity=${entity}&entityId=${entityId}&name=${name}`} className={addButtonStyle}>
              {t('add')}
            </Link>
          )}
        </div>
        <div className="space-y-3">
          {comments.map((c, ci) => (
            <Comment key={ci} {...c} />
          ))}
        </div>
      </div>
    )
}
